import { BaseSchema, BlazeTableSchema } from '@blaze-shared/schema-domain';
import { Connection, GetWorkflowNode, Workflow } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WORKFLOW_SCHEMA_KEY,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Get')
export class GetNodeSchemaProvider extends SchemaProvider<GetWorkflowNode> {
  override getSchemas(
    workflow: Workflow,
    node: GetWorkflowNode,
    schemas: {
      input: Map<string | symbol, BaseSchema>;
      output: Map<string | symbol, BaseSchema>;
      allSchemas: Record<string, BaseSchema>;
      userSchema?: BlazeTableSchema | null;
      accountSchema?: BlazeTableSchema | null;
    },
    connections: Connection[],
  ): Map<string | symbol, BaseSchema> {
    const nodeSchemas = super.getSchemas(workflow, node, schemas, connections);

    if (node.datasetId) {
      nodeSchemas.set(WORKFLOW_SCHEMA_KEY, schemas.allSchemas[node.datasetId]);
    }

    return nodeSchemas;
  }
}
